// if(($("#MainContent div.shopify-section:first-child section").attr('id') != 'featured-image') && ($("#MainContent div.shopify-section:first-child section").attr('id') != 'sOne') ){
//     $("span.header__icon-line").addClass("line-black");
//     $("span.icon-header_logo").addClass("d-none");
//     $("span.icon-header_logo-black").removeClass("d-none");

//     $("span.icon-header_sublogo").addClass("d-none");
//     $("span.icon-header_sublogo_black").removeClass("d-none");

//     $("span.icon-header_menu").addClass("d-none");
//     $("span.icon-header_menu_black").removeClass("d-none");

//     $(".header__inline-menu a.list-menu__item:not(.header__book) span").css("color","#343434");
// }

//  check header light dark
$(document).ready(function () {
  var hasBanner1 = $("#MainContent")
    .children(":nth-child(1)")
    .hasClass("has-banner");
  var hasBanner = $("#MainContent")
    .children(":nth-child(2)")
    .hasClass("has-banner");
  if (hasBanner || hasBanner1) {
    $("#shopify-section-header .header-wrapper ").removeClass("header-dark");
    $("#shopify-section-header .header-wrapper ").addClass("header-light");
  } else {
    $("#shopify-section-header .header-wrapper ").removeClass("header-light");
    $("#shopify-section-header .header-wrapper ").addClass("header-dark");
  }
});
